// Shared contract for user-facing text search.
//
// NFD separates base letters from combining marks; removing Unicode marks
// makes searches such as "sao" match "São" without changing display values.

export function foldText(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

export function matchesFoldedQuery(query, ...candidates) {
  const foldedQuery = foldText(query).trim();
  if (!foldedQuery) return true;
  return candidates.some((candidate) => foldText(candidate).includes(foldedQuery));
}